import { useEffect, useState } from 'react';
import { axiosInstance } from 'utils/axios';

// material-ui
import { Box, Button, Grid, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Checkbox } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import { deepPurple } from '@mui/material/colors';
import { gridSpacing } from 'app/constant';
import { useSelector } from 'react-redux';
import { selectCurrentUser, selectCurrentToken } from 'features/auth/authSlice';
import StickyHeadTable from './components/StickyHeadTable';
import { errorAlert } from 'ui-component/Toasts';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useFetchData from 'hooks/useFetchData';
import * as XLSX from 'xlsx';

const ReferralTeamSales = () => {
    const user = useSelector(selectCurrentUser);
    const token = useSelector(selectCurrentToken);
    const theme = useTheme();

    console.log(token);

    const [referralTeamSales, setreferralTeamSales] = useState([]);
    const [filterReferralSalesFrom, setfilterReferralSalesFrom] = useState(dayjs());
    const [filterReferralSalesTo, setfilterReferralSalesTo] = useState(dayjs());
    const [filterReferralLoginUserName, setFilterReferralLoginUserName] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [filterBtnDisabled, setFilterBtnDisabled] = useState(false);

    const fetchreferralTeamSalesRecord = async () => {
        let referralTeamSalesRecordURL = `/Referral/TeamSales/Report?`;
        if (filterReferralSalesFrom !== '') {
            referralTeamSalesRecordURL += `&dateFrom=${filterReferralSalesFrom.format('YYYY-MM-DD')}`;
        }
        if (filterReferralSalesTo !== '') {
            referralTeamSalesRecordURL += `&dateTo=${filterReferralSalesTo.format('YYYY-MM-DD')}`;
        }
        if (filterReferralLoginUserName !== '') {
            referralTeamSalesRecordURL += `&loginUserName=${filterReferralLoginUserName}`;
        }
        setLoading(true);
        setFilterBtnDisabled(true);
        try {
            const res = await axiosInstance.get(referralTeamSalesRecordURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                setreferralTeamSales(res.data);
                console.log(res.data);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
            setFilterBtnDisabled(false);
        }
    };

    const [exportDataListLoading, setExportDataListLoading] = useState(false);
    function convertDataForSheet(data) {
        if (!data || data.length === 0) {
            warningAlert('There is no data to export');
            throw new Error('Data array is empty or undefined.');
        }

        const headers = Object.keys(data[0]);
        const dataArray = [headers];

        data.forEach((item) => {
            const row = headers.map((key) => item[key]);
            dataArray.push(row);
        });

        return XLSX.utils.aoa_to_sheet(dataArray);
    }
    const exportDataAsXlsx = async () => {
        setFilterBtnDisabled(true);
        setTimeout(() => {
            setFilterBtnDisabled(false);
        }, 3000);
        setExportDataListLoading(true);

        let referralTeamSalesRecordURL = `/Referral/TeamSales/Report?`;
        if (filterReferralSalesFrom !== '') {
            referralTeamSalesRecordURL += `&dateFrom=${filterReferralSalesFrom.format('YYYY-MM-DD')}`;
        }
        if (filterReferralSalesTo !== '') {
            referralTeamSalesRecordURL += `&dateTo=${filterReferralSalesTo.format('YYYY-MM-DD')}`;
        }
        if (filterReferralLoginUserName !== '') {
            referralTeamSalesRecordURL += `&loginUserName=${filterReferralLoginUserName}`;
        }

        try {
            const res = await axiosInstance.get(referralTeamSalesRecordURL, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (res.status === 200) {
                const fileName = `ReferralTeamSales_${dayjs().format('MM-DD-YYYY')}`;
                const workbook = XLSX.utils.book_new();
                const worksheet = convertDataForSheet(res.data);
                // Adjust column widths
                const headers = Object.keys(res.data[0]);
                const colWidths = headers.map((header) => ({ wch: header.length + 2 }));

                worksheet['!cols'] = colWidths;

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                XLSX.writeFile(workbook, `${fileName}.xlsx`);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setExportDataListLoading(false);
        }
    };
    
    const { data: customerLoginUserNameOptions } = useFetchData('/Customer/LoginUserNames');

    return (
        <Grid container item xs={12} padding="20px">
            <Grid item container xs={12} spacing={gridSpacing} sx={{ marginBottom: '10px', overflowY: 'auto' }}>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            From :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralSalesFrom}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setfilterReferralSalesFrom(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            To :
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={filterReferralSalesTo}
                                slotProps={{
                                    textField: {
                                        error: false
                                    }
                                }}
                                onChange={(newValue) => setfilterReferralSalesTo(newValue)}
                            />
                        </LocalizationProvider>
                    </Box>
                </Grid>
                <Grid item container xs={12} md={6} lg={4}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Login UserName :
                        </Typography>
                        <Autocomplete
                            freeSolo
                            value={filterReferralLoginUserName}
                            onChange={(event, newValue) => {
                                setFilterReferralLoginUserName(newValue);
                            }}
                            inputValue={filterReferralLoginUserName}
                            onInputChange={(event, newInputValue) => {
                                setFilterReferralLoginUserName(newInputValue);
                            }}
                            id="controllable-states-demo"
                            options={customerLoginUserNameOptions}
                            sx={{ width: 170 }}
                            renderInput={(params) => <TextField {...params} />}
                            disableClearable
                        />
                    </Box>
                </Grid>
                <Grid item container xs={12} md={12} lg={12}>
                    <Button
                        variant="contained"
                        sx={{
                            float: 'right',
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '30px'
                        }}
                        onClick={() => fetchreferralTeamSalesRecord()}
                        disabled={filterBtnDisabled}
                    >
                        Filter
                    </Button>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                        onClick={() => exportDataAsXlsx()}
                        disabled={filterBtnDisabled}
                    >
                        Export Data
                    </Button>
                </Grid>
                <Box sx={{ width: '100%', minHeight: '200px' }}>
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <StickyHeadTable referralTeamSales={referralTeamSales} />
                    )}
                </Box>
            </Grid>
        </Grid>
    );
};

export default ReferralTeamSales;
